<script setup lang="ts">
const items = [
  {
    title: 'Paket Hilang',
    description:
      'Paket bisa hilang di perjalanan tanpa kejelasan, entah karena salah penanganan atau hilang di jalur pengiriman.',
    icon: 'material-symbols:orders-outline'
  },
  {
    title: 'Paket Rusak',
    description:
      'Barang tiba dalam kondisi tidak sesuai, mengalami kerusakan akibat benturan atau penanganan yang kurang hati-hati selama pengiriman.',
    icon: 'material-symbols:heart-broken-outline'
  },
  {
    title: 'Klaim Lama',
    description:
      'Ketika masalah terjadi, proses klaim sering kali memakan waktu lama hingga membuat pengirim menanggung kerugian lebih lama.',
    icon: 'material-symbols:feedback-outline'
  }
]

const { isMobile } = useBreakpoints()
</script>

<template>
  <UiSectionWrapper
    image-class="lg:order-first"
    title="Resiko Pengiriman Tak Bisa Dihindari, Tapi Kerugian Bisa Diminimalkan"
    hero-image="/images/klaim-asuransi-dan-retur-banner-2.webp"
    class="py-12"
  >
    <template #action>
      <div class="mt-6 lg:mt-12 flex flex-col gap-6 text-lg leading-7">
        <div
          v-for="(item, index) in items"
          :key="index"
          class="flex items-start gap-3"
        >
          <div
            class="p-2 rounded-full bg-primary-container flex-none text-primary"
          >
            <Icon :name="item.icon" :size="isMobile ? '22px' : '30px'" />
          </div>
          <div class="flex-1 flex flex-col gap-2">
            <p class="text-sm lg:text-xl font-bold lg:font-semibold">
              {{ item.title }}
            </p>
            <p class="text-sm lg:text-base text-outline">
              {{ item.description }}
            </p>
          </div>
        </div>
      </div>
    </template>
  </UiSectionWrapper>
</template>
